import { Resource } from "@exibra/shared";
import { RouteObject } from "react-router";
import { Templates } from "./templates";
import { CreateTemplate } from "./pages/create-template/create-template";
import { EditTemplate } from "./pages/edit-template/edit-template";

export const templateRouterConfig: RouteObject[] = [
    {
        path: Resource.Template,
        children: [
            {
                index: true,
                element: <Templates />,
            },
            {
                path: "new",
                element: <CreateTemplate />,
            },
            {
                path: "edit/:templateId",
                element: <EditTemplate />,
            },
        ],
    },
];
